module.exports = __webpack_public_path__ + "img/ico_biaoqianlonghunshi.1fdc70f0.png";